// extracted by mini-css-extract-plugin
module.exports = {"title":"Signup_title__9jz7L"};